export default __webpack_public_path__ + "media/eduJeremyMcIver.572b294a.jpg";